module.exports = __webpack_public_path__ + "static/media/SR105-P5 Copy.36a02e17.png";